import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { User } from 'features/user'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { RESEND_INVITATION } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseResendInvitation } from './types'

export const useResendInvitation = (): UseResendInvitation => {
  const { t } = useTranslation('features/user')
  const { enqueueSnackbar } = useSnackbar()

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: RESEND_INVITATION,
    onCompleted: async (data: Data): Promise<void> => {
      const {
        resendInvitation: { errors },
      } = data

      if (errors && errors.length > 0) {
        enqueueSnackbar(t('resendInvitation.action.error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('resendInvitation.action.success'), { variant: 'success' })
      }
    },
  })

  const resend = (id: User['id']) => {
    void mutateAsync({
      input: {
        userId: id,
      },
    })
  }

  return {
    loading: isPending,
    resend,
  }
}
